import React, { useState } from 'react';
import { graphql } from 'gatsby';
import CtaLink from '../Global/CtaLink';
//@ts-ignore
import * as styles from './CtaContainer.module.css';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import {
    CTAConfiguration,
    BrandColor,
    KontentRichText,
    CtaTsType,
} from '../../../types/KontentProps';
import { getColor, getMultiChoice } from '../Global/DataUtils';

interface Props extends CTAConfiguration {
    kontentItemId?: string;
    ctas: {
        value: CtaTsType[];
    };
}

const CtaContainer: React.FC<Props> = ({ kontentItemId, ctas, ...props }) => {
    const cta = ctas.value;

    return (
        <div data-kontent-item-id={kontentItemId}>
            {cta.map((cta, index) => (
                <div className={styles.ctaContainer} key={index}>
                    <CtaLink
                        key={index}
                        href={BuildLinkHref(
                            cta.elements.cta_location,
                            cta.elements.cta_location_anchor_point
                        )}
                        target={
                            getMultiChoice(cta.elements.cta_window_action) ===
                            'new_window'
                                ? '_blank'
                                : undefined
                        }
                        elementCodename="cta_label"
                    >
                        {cta.elements.cta_label.value}
                    </CtaLink>
                </div>
            ))}
        </div>
    );
};

export default CtaContainer;

export const fragmentCtaContainer = graphql`
    fragment CtaContainer on kontent_item_component___cta_container {
        elements {
            ctas {
                value {
                    ...kontentCta
                }
            }
        }
    }
`;
